<template>
  <div>

    <div style="display: flex; flex-direction: column">
      <span style="font-size: 20px; font-weight: 500">Votre badge actuel :</span>
      <img width="90px" class="my-3 ml-12" :src="badgeSVGsource"/>
    </div>

    <apexchart width="600"
               type="line"
               v-if="ranksChart"
               :series="ranksChart.series"
               :options="ranksChart.options"/>
  </div>
</template>

<script>
import IriadeBlockMixin from '../IriadeBlockMixin'
import moment from 'moment';

export default {
  mixins: [IriadeBlockMixin],

  computed: {
    ranksChart () {
      if (!this.block.config['ranksHistory']) {
        return false
      }

      return {
        chart: {
          width: this.printing ? "75%" : "100%",
          height: "500px",
        },
        series: [{
          data: Object.values(this.block.config['ranksHistory']).map(v => v.rank),
        }],
        options: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          title: {
            text: "Historique de vos badges :",
            offsetX: -10,
            style: {
              fontSize:  '20px',
              fontWeight:  '500',
            },
          },
          colors: [this.$application['primary_color']],
          plotOptions: {
            bar: {
              horizontal: true,
            }
          },
          stroke: {
            curve: 'stepline',
          },
          dataLabels: {
            enabled: true,
            formatter: this.rankNumberToString,
          },
          xaxis: {
            categories: Object.values(this.block.config['ranksHistory']).map(v => moment(v.created_at).format("D MMM Y")),
            axisBorder: {
              show: true,
              color: '#78909C',
              offsetX: 0,
              offsetY: 0
            },
            axisTicks: {
              show: true,
              borderType: 'solid',
              color: '#78909C',
              width: 6,
              offsetX: 0,
              offsetY: 0,
            },
          },
          yaxis: {
            tickAmount: 1,
            labels: {
              show: true,
              maxWidth: 300,
              formatter: this.rankNumberToString,
            },
            min: 0,
            max: 4,
            axisBorder: {
              show: true,
              color: '#78909C',
              offsetX: 0,
              offsetY: 0,
            },
            axisTicks: {
              show: true,
              borderType: 'solid',
              color: '#78909C',
              width: 6,
              offsetX: 0,
              offsetY: 0
            },
          }
        }
      }
    },

    badgeSVGsource () {
      switch (this.block.config['lastRank'].rank) {
        case 0:
          return 'oncolife/images/badge-bleu.svg';
        case 1:
          return 'oncolife/images/badge-bronze.svg';
        case 2:
          return 'oncolife/images/badge-argent.svg';
        case 3:
          return 'oncolife/images/badge-or.svg';
        case 4:
          return 'oncolife/images/badge-platine.svg';
      }

      return '';
    },
  },

  methods: {
    rankNumberToString(rank) {
      switch (rank) {
        case 0:
          return 'Bleu';
          break;
        case 1:
          return 'Bronze';
          break;
        case 2:
          return 'Argent';
          break;
        case 3:
          return 'Or';
          break;
        case 4:
          return 'Platine';
          break;
      }
    },
  },
}
</script>
